(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("TalkFlow", [], factory);
	else if(typeof exports === 'object')
		exports["TalkFlow"] = factory();
	else
		root["TalkFlow"] = factory();
})(self, () => {
return 